import { AppBar, IconButton, Toolbar } from "@mui/material";
import React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import ShellAccountActions from "../../components/Header/ShellAccountActions";
import ThemeToggle from "../../components/GeneralComponents/ThemeToggle";

export default function AppHeader({
  drawerWidth,
  handleDrawerToggle,
  handlePermanentDrawer,
}) {
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
        boxShadow: "none",
        backgroundColor: "var(--portal-theme-secondary)",
        color: "var(--text-primary-color)",
      }}
      className="app-header"
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { xs: "block", sm: "none" } }}
        >
          <MenuIcon />
        </IconButton>
        <IconButton
          color="inherit"
          aria-label="toggle sidebar"
          edge="start"
          onClick={handlePermanentDrawer}
          sx={{ mr: 2, display: { xs: "none", sm: "block" } }}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>
      <div className="d-flex gap-3 pe-3 align-items-center">
        <ThemeToggle variant="header" />
        <ShellAccountActions />
      </div>
    </AppBar>
  );
}
